import { Component, input } from '@angular/core';

@Component({
  selector: 'app-chat-layout',
  standalone: true,
  templateUrl: './chat-layout.component.html',
  styleUrl: './chat-layout.component.scss',
})
export class ChatLayoutComponent {
  /** En mobile solo se ve una columna: false la lista, true el detalle. */
  readonly detalleAbierto = input(false);
}
